export default __webpack_public_path__ + "static/media/entrega.af2b245e.svg";